import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const useStyles = makeStyles((theme)=>({
    row:{
      maxWidth:'400px', 
      margin:'0 auto', 
      padding:'270px 0px 50px 0px',
      
      fontFamily:[
        'Noto Sans KR'
      ],

      [theme.breakpoints.down(1025)]: {
        padding:'150px 0 0px 0',
      }
    },
    checkPassDiv:{
      padding:'30px 0',

      [theme.breakpoints.down(1025)]: {
        padding:' 0px',
      }
    },
    checkPassH1:{ 
      fontSize:'35px', 
      textAlign:'center', 
      padding:'0 0 40px 0'
    },
    inputBtnDiv:{
      display:'flex', 
      justifyContent:'center',
    },
    passwordInput:{
      width:'60%',
      padding:'9px 7px',
      marginRight:'10px',
      height:'50px',
      letterSpacing:'-0.7px',
      fontSize:'13px',
      borderRadius:'3px',
      border:'1px solid #ccc',
      '&::placeholder':{
        color:'#CCCCCC'
      },
      '&:focus-within':{
        outline:'none'
      },
  
      fontFamily:[
        'Noto Sans KR'
      ]
    },
  
  }));


const CheckPass = () => {
    let navigate = useNavigate();
    const theme = useTheme();
    const classes = useStyles(theme);
    const mbNo = useSelector(state => state.user.userInfo['mb_no']);
    const login = useSelector(state => state.user.login);
    const [password, setPassword] = useState('');
    const [dialog, setDialog] = useState('');

    useEffect(() => {
      if(!login){
        navigate("/Login");
      }
  
    }, [login])

    const onCheck = async() => {
        if (!mbNo) return setDialog('로그인 확인 해주세요.')
        if (password === '') return setDialog('비밀번호를 입력 해주세요.')

        try {
            const res = await axios.post('/api/user/checkPassword/', {mb_no: mbNo, mb_password: password})

            if(res.data.success === false && res.data.code === 6) {
                setDialog('비밀번호가 틀립니다.')
                return;
            }
            if(res.data.success === false) {
                setDialog('불러오기 실패')
                return;
            }

            navigate("/EditProfile", {
                state: { auth: true }
            });
        
          } catch (e) {
            console.log(e)
          }

    }

    useEffect(() => {

      return () => {
        setPassword('')
      }
    }, [])

    return (
    <div className={classes.checkPassBlock}>
        <div className={classes.row}>
          <div className={classes.checkPassDiv}>
            <h1 className={classes.checkPassH1}>비밀번호 확인</h1>
            <div className={classes.inputBtnDiv}>
              <input 
                  className={classes.passwordInput} 
                  type='password' 
                  id='password' 
                  name='password' 
                  value={password} 
                  onChange={(e) => {setPassword(e.target.value)}}
                  placeholder='비밀번호를 입력해주세요'
                  onKeyDown={(e) => {
                    if(e.key === 'Enter') {
                      onCheck()
                    }
                  }}
              />
              <Button 
                  variant="outlined"
                  onClick={() => onCheck()}
                  style={{ 
                    color:'#007235',
                    border:'1px solid #007235',
                    fontFamily:[
                      'Noto Sans KR'
                    ]
                  }}
              >
                  확인
              </Button>
            </div>
          </div>
        </div>

        <Dialog
        open={dialog === '' ? false : true}
        onClose={() => setDialog('')}
      >
        <DialogTitle id="alert-dialog-title">
          {dialog}
        </DialogTitle>
        <DialogActions>
          <Button onClick={() => setDialog('')} autoFocus>
            확인
          </Button>
        </DialogActions>
      </Dialog>

    </div>
    )
}

export default CheckPass
